export function sortedByName(sortArray?: any[]) {
  if (!Array.isArray(sortArray)) return [];
  return [...sortArray]?.sort((a, b) => a?.name?.localeCompare(b?.name));
}
export function getSortedCountry(sortArray?: any[]) {
  if (!Array.isArray(sortArray)) return [];
  return [...sortArray]?.sort((a, b) => a?.label?.localeCompare(b?.label));
}
export function getSortedRegionOptions(sortArray?: any[]) {
  if (!Array.isArray(sortArray)) return [];
  return [...sortArray].sort((a, b) => a?.label?.localeCompare(b?.label));
}
